import api from '../utilities/api';

export default {
    tags() {
        return api.v2.get('personal-profile/tags').then((val) => val.body.tags);
    },
    updateTags(tags) {
        return api.v2.put('personal-profile/tags', {
            tags: tags
        });
    },
    getReviewerContacts() {
        return api.v2.get('profile/reviewer-contacts').then((val) => val.body.items || []);
    },
    createReviewerContact(payload) {
        return api.v2.post('profile/reviewer-contacts', payload).then((val) => val.body.item);
    },
    updateReviewerContact(id, payload) {
        return api.v2.put(`profile/reviewer-contacts/${id}`, payload).then((val) => val.body.item);
    },
    deleteReviewerContact(id) {
        return api.v2.delete(`profile/reviewer-contacts/${id}`);
    }
}
